import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Red_Outline_Btn.css'

const Red_Outline_Btn = ({ btnText, onClick , type = "button" }) => {
    return (
        <section className="Red_Outline_Btn_holder" >
            <Button className="Red_Outline_Btn" type={type} onClick={onClick}>{btnText}</Button>
        </section>

    )
}

export default Red_Outline_Btn
